"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from "react";
import useWavesList from "@/hooks/useWavesList";
import useNewDropCounter, { MinimalWaveNewDropsCount, getNewestTimestamp } from "./useNewDropCounter";
import { ApiWave } from "@/generated/models/ApiWave";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
export interface MinimalWave {
  id: string;
  name: string;
  type: ApiWaveType;
  newDropsCount: MinimalWaveNewDropsCount;
  picture: string | null;
  contributors: {
    pfp: string;
  }[];
  isPinned: boolean;
}
function useEnhancedWavesList(activeWaveId) {
  const $ = _c(17);
  const wavesData = useWavesList();
  const {
    newDropsCounts,
    resetAllWavesNewDropsCount
  } = useNewDropCounter(activeWaveId, wavesData.waves, wavesData.mainWavesRefetch);
  let t0;
  if ($[0] !== newDropsCounts) {
    t0 = wave => {
      const newDrops = {
        count: newDropsCounts[wave.id]?.count ?? 0,
        latestDropTimestamp: getNewestTimestamp(newDropsCounts[wave.id]?.latestDropTimestamp, wave.metrics.latest_drop_timestamp ?? null)
      };
      return {
        id: wave.id,
        name: wave.name,
        type: wave.wave.type,
        picture: wave.picture,
        contributors: wave.contributors_overview.map(_temp),
        newDropsCount: newDrops,
        isPinned: wave.isPinned ?? false
      };
    };
    $[0] = newDropsCounts;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const mapWave = t0;
  let t1;
  if ($[2] !== mapWave || $[3] !== wavesData.waves) {
    t1 = wavesData.waves.map(mapWave);
    $[2] = mapWave;
    $[3] = wavesData.waves;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const minimal = t1;
  let t2;
  if ($[5] !== minimal) {
    t2 = [...minimal].sort(_temp2);
    $[5] = minimal;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const sorted = t2;
  let t3;
  if ($[7] !== resetAllWavesNewDropsCount || $[8] !== sorted || $[9] !== wavesData.addPinnedWave || $[10] !== wavesData.fetchNextPage || $[11] !== wavesData.hasNextPage || $[12] !== wavesData.isFetching || $[13] !== wavesData.isFetchingNextPage || $[14] !== wavesData.refetchAllWaves || $[15] !== wavesData.removePinnedWave) {
    t3 = {
      waves: sorted,
      isFetching: wavesData.isFetching,
      isFetchingNextPage: wavesData.isFetchingNextPage,
      hasNextPage: wavesData.hasNextPage,
      fetchNextPage: wavesData.fetchNextPage,
      addPinnedWave: wavesData.addPinnedWave,
      removePinnedWave: wavesData.removePinnedWave,
      refetchAllWaves: wavesData.refetchAllWaves,
      resetAllWavesNewDropsCount
    };
    $[7] = resetAllWavesNewDropsCount;
    $[8] = sorted;
    $[9] = wavesData.addPinnedWave;
    $[10] = wavesData.fetchNextPage;
    $[11] = wavesData.hasNextPage;
    $[12] = wavesData.isFetching;
    $[13] = wavesData.isFetchingNextPage;
    $[14] = wavesData.refetchAllWaves;
    $[15] = wavesData.removePinnedWave;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  return t3;
}
function _temp2(a, b) {
  return (b.newDropsCount.latestDropTimestamp ?? 0) - (a.newDropsCount.latestDropTimestamp ?? 0);
}
function _temp(c) {
  return {
    pfp: c.contributor_pfp
  };
}
export default useEnhancedWavesList;